export const getLineCenters = (lines, scale) => {
    if (lines) {
        return Object.values(lines).map(line => {
            const distance = line.length() * scale;
            line.update();
            return {
                position: {
                    x: (line.start.x + line.end.x) * 0.5 * scale,
                    y: (line.start.y + line.end.y) * 0.5 * scale,
                    z: (line.start.z + line.end.z) * 0.5 * scale
                },
                dim: 'height',
                wall: 'inner',
                distance: distance
            };
        });
    }
    return [];
};
export const getInnerLineCenterPoints = (lineCenters, coreApi) => {
    return lineCenters.flatMap((center) => {
        const { position, dim, wall, distance } = center;
        const point = coreApi
            .getModules()
            .viewer()
            ?.worldCoordToCanvas(position.x, position.y, position.z);
        if (point) {
            return {
                dim,
                wall,
                x: point.X,
                y: point.Y,
                distance: distance
            };
        }
        return [];
    });
};
//# sourceMappingURL=measurementUtils.js.map